const STORAGE_KEYS = [
  "auth-token",
  "user-name",
  "roles",
  "email",
  "company",
  "user",
  "walkthrough",
  "subscribedStatus",
  "planType",
  "coupon",
  "status",
  "adminToken",
  "isImpersonating",
  "impersonatedBy",
  // Written whenever an admin clicks into a company. Absent from this list it
  // survived logout, so the next person to sign in on the machine inherited the
  // previous admin's last-viewed company.
  "selectedCompany",
];

/**
 * Decide storage:
 * - If impersonating → sessionStorage
 * - Else → localStorage
 */
const getStorage = () => {
  if (sessionStorage.getItem("auth-token")) {
    return sessionStorage;
  }
  return localStorage;
};

const authStorage = {
  getItem(key) {
    const storage = getStorage();
    const value =
      storage.getItem(key) ??
      localStorage.getItem(key) ??
      sessionStorage.getItem(key);

    if (value === null) return null;

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },

  setItem(key, value) {
    const storage = getStorage();
    storage.setItem(
      key,
      typeof value === "string" ? value : JSON.stringify(value)
    );
  },

  removeItem(key) {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  },

  clear() {
    STORAGE_KEYS.forEach((key) => {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    });
  },

  isImpersonating() {
    return !!sessionStorage.getItem("auth-token");
  },
};

export default authStorage;
